import { useState } from 'react';

import { usePagination } from '../../../common/hooks/usePagination';

import { useDebouncedValue } from '../../../common/hooks/useDebouncedValue';
import { useTableSort } from '../../../common/hooks/useTableSort';
import { useMaterialValuationPreflight } from '../../../hooks/useMaterialCosts';
import { PREFLIGHT_SOURCE_BY_TAB, VALUATION_TABS } from '../constants/materialValuationConstants';

const PURCHASES_SOURCE = PREFLIGHT_SOURCE_BY_TAB[VALUATION_TABS.purchases];

/**
 * Compras y retornos anteriores al costeo: búsqueda, página y orden de la pestaña activa.
 * @param {string} activeTab Pestaña activa de la pantalla.
 * @returns {Object} Renglones, totales de ambos listados, filtros y handlers.
 */
export const useMaterialValuationSources = (activeTab) => {
  const { page, setPage, rowsPerPage, handleRowsPerPageChange } = usePagination();
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebouncedValue(search);
  const tableSort = useTableSort(() => setPage(1));
  const source = PREFLIGHT_SOURCE_BY_TAB[activeTab] || PURCHASES_SOURCE;
  const isPurchases = source === PURCHASES_SOURCE;

  const query = useMaterialValuationPreflight({
    source,
    page,
    per_page: rowsPerPage,
    search: debouncedSearch || undefined,
    ...tableSort.sortParams,
  });
  const data = query.data;

  return {
    rows: (isPurchases ? data?.purchases : data?.possible_returns) || [],
    totalCount: (isPurchases ? data?.purchase_count : data?.possible_return_count) || 0,
    purchaseCount: data?.purchase_count,
    returnCount: data?.possible_return_count,
    page,
    rowsPerPage,
    handleRowsPerPageChange,
    search,
    sort: tableSort.sort,
    isLoading: query.isLoading,
    error: query.isError ? query.error : null,
    refetch: query.refetch,
    changePage: (_, value) => setPage(value),
    changeSearch: (value) => {
      setSearch(value);
      setPage(1);
    },
    toggleSort: tableSort.toggleSort,
    reset: () => {
      setPage(1);
      setSearch('');
      tableSort.resetSort();
    },
  };
};
